<template>
	<div>
    <el-row style="margin-bottom:10px;">
      <el-select v-model='theSelectProjectId' v-if="theUserProject==0" clearable size="small" @change="theSelectProjectChange" placeholder="请选择项目">
          <el-option
              v-for="item in getProjectList_data.data||[]"
              :key="item.projectId"
              :label="item.projectName"
              :value="item.projectId">
          </el-option>
      </el-select>
      <el-button
          @click="toExportExcelWg"
          type="primary"
          icon='el-icon-search'
          size='small'
          style='margin-left:10px;'
        >导出区域数据
        </el-button>
        <el-date-picker
          v-model="valueDate"
          size='small'
          type="datetimerange"
          :picker-options="pickerOptions"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="timeChange"
          value-format="yyyy-MM-dd HH:mm:ss"
          align="right">
        </el-date-picker>
      <el-button
          @click="toExportExcelSts"
          type="primary"
          icon='el-icon-search'
          size='small'
          style='margin-left:10px;'
        >导出学员数据
        </el-button>
    </el-row>
		<mytable ref="mytable"
		  :tree="{children: 'children', lazy: lazyLoad}"
		  :tableColums='tableColums_getProjectAnalysis'
		  api='getProjectAnalysis::dtId'
		  xupdateapi='updateUserTarget'
		  :height="H-165"
		  @expand="expand">
		</mytable>
	</div>
</template>

<script>
  import qs from 'qs';
  import axios from 'axios';

	export default {
		data(){
			return {
        loading: "",
        theProjectId:"",
        theSelectProjectId: "",
				tableColums_getProjectAnalysis:{
					$selection: false,
					dtName: ['战队|align:left',400],
					dtOrderNum: '订单数',
					dtPoints: '积分',
					dtVisitorNum: '拜访量',
					dtYj: '业绩',
					dtBusinessNum: '数量',
				},
        baseUrl: $Api.baseUrl_online,
        valueDate:"",
        startDate:"",
        endDate:"",
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
			}
		},
		methods:{
      openLoading() {
        //loading请求等待
        this.loading = this.$loading({
          lock: true,
          text: "加载中...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });
      },
      timeChange(e){
        if(e){
          this.startDate= e[0];
          this.endDate= e[1];
        }else{
          this.startDate= "";
          this.endDate= "";
        }
        
      },
      toExportExcelWg: async function(){
        const that = this;
        that.openLoading();
        axios({
            method: 'post',
            url: that.baseUrl + '/opportunity/user/exportProjectAnalysisWg',
            data: {},
            withCredentials: true,
            timeout: 1200000,
            responseType: 'arraybuffer',
            headers: {
                Accept: "application/json",
                "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                'token': A.local('$Usertoken'),
                'projectId': +A.local('$projectId'),
            }
        }).then(function (response) {
            that.loading.close();
            let a = document.createElement('a');
            //ArrayBuffer 转为 Blob
            let blob = new Blob([response.data], {type: "application/vnd.ms-excel"});
            let objectUrl = URL.createObjectURL(blob);
            a.setAttribute("href", objectUrl);
            a.setAttribute("download", '区域.xlsx');
            a.click();
            that.$message({
                message: "成功",
                type: "success"
            });
        }).catch(function (error) {
            that.loading.close();
            console.log(error);
        });
      },
      toExportExcelSts: async function(){
        const that = this;
        var postData = {
          startDate:that.startDate,
          endDate:that.endDate
        };
        var s = qs.stringify(postData);
        that.openLoading();
        axios({
            method: 'post',
            url: that.baseUrl + '/opportunity/user/exportProjectAnalysisSts',
            data: s,
            withCredentials: true,
            timeout: 1200000,
            responseType: 'arraybuffer',
            headers: {
                Accept: "application/json",
                "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                'token': A.local('$Usertoken'),
                'projectId': +A.local('$projectId'),
            }
        }).then(function (response) {
            that.loading.close();
            let a = document.createElement('a');
            //ArrayBuffer 转为 Blob
            let blob = new Blob([response.data], {type: "application/vnd.ms-excel"});
            let objectUrl = URL.createObjectURL(blob);
            a.setAttribute("href", objectUrl);
            a.setAttribute("download", '学员.xlsx');
            a.click();
            that.$message({
                message: "成功",
                type: "success"
            });
        }).catch(function (error) {
            that.loading.close();
            console.log(error);
        });
      },
      theSelectProjectChange(e){
          //搜索

      this.getProjectAnalysis({ projectId:e});


      },
			expand(row, expanded) {
        // return console.warn(row,expanded);
			  if( row.dtLevel == 1 || row.hasChildren2 === false ) return;
        const treeData = this.$refs.mytable.Table.store.states.treeData, children = ( treeData[ row._parent ] || 0 ).children || '';
        if( children.length < 2 ) return;
        // console.error(row, expanded, row._parent, children, row.hasChildren);
        for( let id of children ) {
            if( id !== row.dtId ) treeData[id] && ( treeData[id].expanded = false );
        };
        return;
			},
			lazyLoad(treeData, treeNode, resolve) {
        // console.warn(treeData);
			  if( treeData.dtLevel > 1 ) {

        };
        axios({
          method: 'post',
          baseURL: $Api.baseUrl_online, //线上
          url: ( Apis.getProjectAnalysis || 0 )[0] || '/opportunity/user/getProjectAnalysis',
          withCredentials: true,
          data: qs.stringify( { dtId: treeData.dtId,projectId:this.getProjectAnalysis_data.projectId } ),
          timeout: 900000,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
            'token': A.local('$Usertoken'),
            'projectId': +A.local('$projectId'),
            // "Set-Cookie": `httpOnly; Secure; SameSite = None`,
            // res.setHeader('Set-Cookie',`name={"loginname":"${userName}"}; httpOnly; Secure; SameSite = None`);
          }
        }).then(res=>{
            let now;
            res = res.data.data || [];
            // console.error(res, treeData._rowIndex);
            if( res.length !== 0 ) return treeData.hasChildren2 = true, resolve(
                treeData.dtLevel != 4
                ? forArr( res, v => ( v.hasChildren = true, v._parent = treeData.dtId ) )
                : forArr( res, v=>(v.dtId = now + res++, v._parent = treeData.dtId, v.dtName = v.userName||v.dtName), res = 1, now = Date.now() )
            );
            treeData.hasChildren2 = false, resolve([]);
        }).catch(err=>{
            resolve([]);
        });

			},
		},
		created() {
			this.getProjectAnalysis();
      this.getProjectList({pageSize:0});
      this.theUserProject=A.local('$projectId');
      if(this.theUserProject!=0){
        this.theProjectId=this.theUserProject;
      }
		}
	}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/bussiness/ProjectAnalyisis.vue